
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class SplittingBOMGrid extends Serenity.EntityGrid<SplittingBOMRow, any> {
        protected getColumnsKey() { return 'Production.SplittingBOM'; }
        protected getDialogType() { return SplittingBOMDialog; }
        protected getIdProperty() { return SplittingBOMRow.idProperty; }
        protected getInsertPermission() { return SplittingBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SplittingBOMRow.localTextPrefix; }
        protected getService() { return SplittingBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}